export default "__VITE_ASSET__Zo3dNtbc__"